(window as any).global = window;

// keycloak-js v26+ uses Promise.withResolvers (ES2024); polyfill for older browsers.
type PromiseWithResolvers = <T>() => {
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: unknown) => void;
};

const PromiseWithPolyfill = Promise as PromiseConstructor & {
    withResolvers?: PromiseWithResolvers;
};

if (typeof PromiseWithPolyfill.withResolvers !== 'function') {
    PromiseWithPolyfill.withResolvers = function withResolvers<T>() {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: unknown) => void;
        const promise = new Promise<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}

